import { useTrackEventForAdoption } from "src/query/adoption";
import {
  TRACK_EMAIL_SIGNATURE_ADDED_EVENT,
  TRACK_PROFILE_CLICKED_EVENT
} from "src/constants/adoption/eventTypes";

import _ from "lodash";
import { SettingsModule } from "src/types/settings/common";


export const useProfileAdoption = () => {
  const { mutate: trackEvent } = useTrackEventForAdoption(SettingsModule.PROFILE);

  const trackEmailSignatureAdded = () => {
    const event = {
      event: TRACK_EMAIL_SIGNATURE_ADDED_EVENT,
      properties: {},
    };
    trackEvent(event);
  };

  const trackProfileClicked = () => {
    const event = {
      event: TRACK_PROFILE_CLICKED_EVENT,
      properties: {},
    };
    trackEvent(event);
  };

  return {
    trackEmailSignatureAdded,
    trackProfileClicked,
  };
};
